<template>
    <div class="relative">
        <label class="block relative" :for="name">
            <span class="block h-0 w-0 overflow-hidden">{{ label }}</span>
            <input type="text"
                   :placeholder="label"
                   class="block p-2 w-full placeholder-opacity-50 border border-opacity-20 border-gray placeholder-gray caret-purple focus:outline-none valid:border-opacity-100 text-gray"
                   :class="[isOpen ? 'rounded-t' : 'rounded']"
                   @input="onChange"
                   autocomplete="off"
                   :id="name"
                   :name="name"
                   :required="required"
                   v-model="search"
                   @keyup.down="onArrowDown"
                   @keyup.up="onArrowUp"
                   @keyup.enter.stop="onEnter" />
        </label>
        <div v-show="isOpen"
             class="overflow-auto absolute top-0 pt-10 w-full max-h-32 rounded border shadow-lg border-purple">
            <ul class="bg-white">
                <li v-for="(result, i) in results"
                    :key="i"
                    @click="setResult(result)"
                    class="px-4 py-2 transition-colors cursor-pointer hover:bg-purple hover:text-white"
                    :class="{ 'bg-purple text-white': i === arrowCounter }">
                    {{ result }}
                </li>
            </ul>
        </div>

    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class AutocompleteInput extends Vue {
    @Prop({ required: true }) items: string[];
    @Prop({ required: true }) name: string;
    @Prop({ required: true }) label: string;
    @Prop({ default: false }) required: boolean;

    isOpen = false;
    results = [];
    search = '';
    arrowCounter = 0;

    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    }

    destroyed() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    onChange() {
        this.$emit('input', this.search);
        this.filterResults();
        this.isOpen = true;
    }

    filterResults() {
        this.results = this.items.filter(item => {
            const regex = new RegExp(`(^|\\s)(${this.search.toLowerCase()})`);
            return item.toLowerCase().match(regex);
            // return item.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
        });
    }

    setResult(result) {
        this.search = result;
        this.isOpen = false;
    }

    onArrowDown() {
        if (this.arrowCounter < this.results.length) {
            this.arrowCounter = this.arrowCounter + 1;
        }
    }

    onArrowUp() {
        if (this.arrowCounter > 0) {
            this.arrowCounter = this.arrowCounter - 1;
        }
    }

    onEnter() {
        this.search = this.results[this.arrowCounter];
        this.isOpen = false;
        this.arrowCounter = -1;
    }

    handleClickOutside(evt) {
        if (!this.$el.contains(evt.target)) {
            this.isOpen = false;
            this.arrowCounter = -1;
        }
    }

    @Watch('items')
    onItemsCHanged(val, oldValue) {
        if (val.length !== oldValue.length) {
            this.results = val;
        }
    }
}
</script>
